// This file must remain a JS file to be used by node
// NOTE - All colors must use full hex value and not short hand in order to support mobile
var accountsBannerUrl = './assets/images/accounts-banner.png';
var newAccountUrl = './assets/images/new-account.png';
var loginBackgroundUrl = './assets/images/login-image.jpg';
var commonPalette = {
  white: '#FFFFFF',
  black: '#000000'
};
var defaultPalette = {
  main: '#F6F6F6',
  contrastText: commonPalette.black
};
var primaryPalette = {
  /** @deprecated */
  light: '#044f93',
  main: '#03427a',

  /** @deprecated */
  dark: '#023561',
  contrastText: commonPalette.white
};
/** @deprecated */

var secondaryPalette = {
  light: '#0088e1',
  main: '#0079c8',
  dark: '#0070b9',
  contrastText: commonPalette.white
};
var callToActionPalette = {
  /** @deprecated */
  light: '#0c9d78',
  main: '#0a8566',

  /** @deprecated */
  dark: '#086d54',
  contrastText: commonPalette.white
};
var greyPalette = {
  light: '#d3d3d3',
  main: '#bcbcbc',
  dark: '#666666'
};
var errorPalette = {
  light: '#dc5959',
  main: '#d32f2f',
  dark: '#020101',
  contrastText: commonPalette.white
};
var actionPalette = {
  disabled: 'rgba(0, 0, 0, 0.26)',
  disabledBackground: 'rgba(0, 0, 0, 0.12)'
};
module.exports = {
  palette: {
    common: commonPalette,
    primary: primaryPalette,

    /** @deprecated */
    secondary: secondaryPalette,
    default: defaultPalette,
    callToAction: callToActionPalette,
    grey: greyPalette,
    error: errorPalette,
    action: actionPalette
  },
  typography: {
    fontFamily: 'Roboto,sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightBold: 700,
    h1: {
      fontSize: 30,
      mobileFontSize: 24
    },
    h2: {
      fontSize: 24,
      mobileFontSize: 21
    },
    h3: {
      fontSize: 18,
      mobileFontSize: 18
    },
    h4: {
      fontSize: 18 // keeping for backwards compatability

    },
    h5: {
      fontSize: 18 // keeping for backwards compatability

    },
    body1: {
      fontSize: 14,
      mobileFontSize: 14
    },
    body2: {
      fontSize: 16,
      mobileFontSize: 16
    },
    subtext: {
      fontSize: 12,
      mobileFontSize: 12
    },
    button: {
      fontSize: 14,
      mobileFontSize: 14
    },
    input: {
      fontSize: 14,
      mobileFontSize: 14,
      borderRadius: 3
    }
  },
  images: {
    newAccountBadge: newAccountUrl,
    accountBanner: accountsBannerUrl,
    login: loginBackgroundUrl
  },
  shadows: {
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
    md: '0 3px 6px 1px rgba(0, 0, 0, 0.2)'
  },
  config: {
    accounts: {
      widgets: {
        approvals: {
          enabled: true,
          order: 1
        },
        messages: {
          enabled: true,
          order: 2
        },
        payTransfer: {
          enabled: true,
          order: 3
        },
        quickTransfer: {
          enabled: true,
          order: 4
        },
        quickPayment: {
          enabled: true,
          order: 5
        },
        p2p: {
          enabled: true,
          order: 6
        },
        cardControls: {
          enabled: true,
          order: 7
        },
        openAccount: {
          enabled: true,
          order: 8
        }
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/styles/defaultTheme.js
// module id = 515
// module chunks = 0